







import Vue from "vue";

export default Vue.extend({
  name: "CopyField",
  props: ["url"],
  methods: {
    copyPath() {
      const copyText: any = document.querySelector("#share-url");
      if (copyText) {
        copyText.select();
        document.execCommand("copy");
      }
    },
  }
});
